/* src/app/modules/employees/acceso/config-acceso.component.css */
.ca-note {
  font-size: 13px;
  color: var(--cf-text-muted, #6b7280);
  margin: 0 0 16px;
}
/*# sourceMappingURL=config-acceso.component.css.map */
